import { formatCurrency } from '../../utils/index.ts';

/**
 * The extra-service field's display value, in the unit the client is typing in.
 *
 * Cents are shown for a daily figure and never for an annual one: $25.75 a day is a real quote, and
 * rounding it to $26 would silently overstate the year by $91. An empty field stays empty rather
 * than showing "$0", so the placeholder can do its job.
 */
export const formatExtraServiceFee = (annual: number, unit: 'daily' | 'annual'): string => {
    if (!annual) return '';
    if (unit === 'annual') return formatCurrency(annual);
    return '$' + (annual / 365).toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};
